import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";

 var mutation = gql`
  mutation removePricingPlan(
    $organizationId: UUID!, 
    $pricingPlanId: UUID!,
    ) {
    removePricingPlan(
        organizationId: $organizationId
        pricingPlanId: $pricingPlanId
    )
  }  
`;



export function apiRemovePricingPlan(organizationId, pricingPlanId) {
    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");


        client
            .mutate({
                mutation: mutation,
                variables: {
                    organizationId,
                    pricingPlanId
                },
                fetchPolicy: "network-only"
            })
            .then((result) => {
                if(result.data.removePricingPlan === true) resolve(result.data.removePricingPlan);
                else reject(result.data.removePricingPlan);
            })
            .catch((err) => {
                toast.error("Api Error, Unable to remove pricing plan");
                reject(err); // R
            })
    });
}
